import React, { useState } from "react";
import countryCodes from "../../datas/countrydata.json";
import Select, { SingleValue } from "react-select";
import { CountryOption } from "../../types/home";

interface Props {
  applicantFormData: any; // Replace 'any' with the specific type if known
  setApplicantFormData: any; // Replace 'any' with the specific type if known
  nameError: any;
  setNameError: any;
  passportNumberError: any;
  setPassportNumberError: any;
  countryError: boolean;
  setCountryError: (val: boolean) => void;
  onProceed: () => void;
}

const FormWithCountrySelector: React.FC<Props> = ({
  applicantFormData,
  setApplicantFormData,
  nameError,
  setNameError,
  passportNumberError,
  setPassportNumberError,
  countryError,
  setCountryError,
  onProceed,
}) => {
  const [countryCode, setCountryCode] = useState("");


  const countryOptions = countryCodes.OldCountry.map((country) => ({
    value: country.iso,
    label: `${country.country}`,
    iso: country.iso,
  }));

  const handleInputChange = (field: any, value: any) => {
    setApplicantFormData((prev: any) => ({ ...prev, [field]: value }));
    if (field === "name") {
      const namereg = /^[A-Za-z\s]{1,30}$/;
      const isValid = namereg.test(value.trim());
      setNameError(value.trim() !== "" && !isValid);
    }
  };

  const handleCountryChange = (
    selectedOption: SingleValue<CountryOption> | null
  ) => {
    if (selectedOption) {
      setCountryCode(selectedOption.value);
      setCountryError(false);
      setApplicantFormData((prev: any) => ({
        ...prev,
        country: selectedOption.value,
      }));
    } else {
      setCountryError(true);
    }
  };

  const handleProceed = (e: React.FormEvent) => {
    e.preventDefault();
    let hasError = false;
    const namereg = /^[A-Za-z\s]{1,30}$/;
    if (
      !applicantFormData.name ||
      !namereg.test(applicantFormData.name.trim())
    ) {
      setNameError(true);
      hasError = true;
    } else {
      setNameError(false);
    }
    if (!applicantFormData.passport) {
      setPassportNumberError(true);
      hasError = true;
    } else {
      setPassportNumberError(false);
    }
    if (!applicantFormData.country) {
      setCountryError(true);
      hasError = true;
    } else {
      setCountryError(false);
    }
    if (!hasError) {
      onProceed();
    }
  };

  return (
    <form className="pt-3" onSubmit={handleProceed}>
      <div className="row g-3">
        <div className="col-12 mb-3">
          <input
            type="text"
            className={`form-control custom-input ${
              nameError ? "input-error" : ""
            }`}
            placeholder="Full Name"
            value={applicantFormData.name}
            onChange={(e) => handleInputChange("name", e.target.value)}
            aria-label="Full Name"
          />
          {nameError && (
            <div className="error-text">Please enter a Valid Name</div>
          )}
        </div>
        <div className="col-12 col-md-6 mb-2">
          <input
            type="text"
            className={`form-control custom-input ${
              passportNumberError ? "input-error" : ""
            }`}
            placeholder="Passport Number"
            value={applicantFormData.passport}
            onChange={(e) => handleInputChange("passport", e.target.value)}
            aria-label="Passport Number"
          />
          {passportNumberError && (
            <div className="error-text">
              Please enter a Correct Passport Number.
            </div>
          )}
        </div>
        <div className="col-12 col-md-6 mb-2">
          <div
            style={{
              flex: "0 0 32%",
              borderRadius: "9px",
              padding: "3px",
              border: countryError ? "2px solid #dc3545" : "1px solid #ced4da",
            }}
          >
            <Select
              options={countryOptions}
              classNamePrefix="custom-select"
              value={countryOptions.find(
                (option) =>
                  option.value === (applicantFormData.country || countryCode)
              )}
              onChange={handleCountryChange}
              isSearchable={true}
              placeholder="Please select Country"
              formatOptionLabel={(option) => (
                <div className="d-flex align-items-center">
                  <span
                    className={`flag-icon flag-icon-${option.value.toLowerCase()} me-2`}
                  />
                  <span>{option.label}</span>
                </div>
              )}
              menuPortalTarget={document.body}
              styles={{
                control: (provided) => ({
                  ...provided,
                  border: "none",
                  boxShadow: "none",
                }),
                container: (provided) => ({
                  ...provided,
                  width: "100%",
                }),
                menu: (provided) => ({
                  ...provided,
                  maxWidth: "20px",
                  maxHeight: "200px",
                  overflowY: "hidden",
                  zIndex: 9999,
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999,
                }),
              }}
            />
          </div>
          {countryError && (
            <div className="error-text">Please select a country</div>
          )}
        </div>
      </div>
    </form>
  );
};

export default FormWithCountrySelector;
